export default "__VITE_ASSET__2512ad7c__"